import { cx } from "class-variance-authority";

import { useBelowBreakpoint } from "../../hooks";

import * as theme from "./SectionGroup.css";

interface SectionGroupProps {
    children: React.ReactNode;
}

// Adds responsive margin, gap
export function SectionGroup({ children }: SectionGroupProps) {
    const belowSm = useBelowBreakpoint("sm");
    const rootClassNames = cx(
        theme.sectionGroup,
        belowSm && theme.sectionGroupBelowSm
    );
    return <div className={rootClassNames}>{children}</div>;
}
